var map = {
	"./0-1years.svg": "194f",
	"./0-3years.svg": "adc7",
	"./0.png": "0b08",
	"./1.png": "775a",
	"./2.png": "8e30",
	"./2020/navigation_bg.png": "4e8c",
	"./26cad-contact_b.jpg": "d00d",
	"./3.png": "1f66",
	"./4-7years.svg": "80e3",
	"./4.png": "5fa5",
	"./5.png": "c037",
	"./6.png": "338d",
	"./Cards.png": "6195",
	"./Cards.svg": "8afc",
	"./Cargando.png": "c02c",
	"./Close.png": "e1fa",
	"./Close.png.webp": "6ce8",
	"./Close.svg": "37db",
	"./Close.svg.webp": "a23a",
	"./Contactofondo.jpg": "62ae",
	"./Disponible-icon.svg": "9309",
	"./Disponible-icon.svg.webp": "72ae",
	"./Episodios.svg": "2dd6",
	"./Episodios.svg.webp": "95c5",
	"./Estrellita-Non-select.svg": "259a",
	"./Estrellita-Non-select.svg.webp": "fc9d",
	"./Estrellita.svg": "d92d",
	"./Estrellita.svg.webp": "12d5",
	"./Fondo_Pantalla_intermedio.png": "c4dd",
	"./Pantalla-Intermedio.jpg": "0696",
	"./PantallaPromo-01.svg": "a647",
	"./PantallaPromo-01.svg.webp": "9cf9",
	"./Paypal-01.svg": "1d56",
	"./Play.svg": "4bd2",
	"./Play.svg.webp": "7f9a2",
	"./Studio-icon-01.svg": "aff5",
	"./VerTrailer-icon-01.svg": "afcc",
	"./VideoPromo-icon.svg": "1e27",
	"./VideoPromo.png": "42a4",
	"./VideoPromo.svg": "7806",
	"./android.png": "64ee",
	"./android.png.webp": "30fa",
	"./arrow_down.png": "669b",
	"./arrow_down.png.webp": "f85f",
	"./arrow_left.png": "27dc",
	"./arrow_left.png.webp": "8952",
	"./arrow_right.png": "16cf",
	"./arrow_right.png.webp": "8854",
	"./arrow_up.png": "4995",
	"./arrow_up.png.webp": "9e87",
	"./bg-igloo.jpg": "b2cf",
	"./bg_foot.jpg": "9fa9",
	"./bgclean.jpg": "380c",
	"./botonPinguino.png": "4667",
	"./botonPinguino.png.webp": "29cc",
	"./brocha.svg": "3a10",
	"./brochazo.png": "e68d",
	"./brush-01.svg": "0c81",
	"./bubble.png": "4b76",
	"./buttt.png": "73b9",
	"./buttt2.png": "4227",
	"./check-blue.png": "aedf",
	"./chevron-der.svg": "9b1b",
	"./chevron-der.svg.webp": "1258",
	"./chevron-derecho-1.svg": "2c1c",
	"./chevron-izq.svg": "7c4e",
	"./chevron-izq.svg.webp": "1fdd",
	"./chevron-izquierdo-1.svg": "017e",
	"./cuentobg.png": "8a5b",
	"./favicon.png": "a171",
	"./fondo-region.jpg": "d875",
	"./fondo.jpg": "d133",
	"./fondo_arboles.jpg": "e31e",
	"./fondo_control_icons-orig.png": "85be",
	"./fondo_control_icons.png": "600d",
	"./fondo_index.jpg": "2865",
	"./fondo_juegos.jpg": "e425",
	"./fondo_juegos.svg": "1275",
	"./fondo_juegos_icon.png": "de55",
	"./fondo_juegos_icon.webp": "5839",
	"./fondo_login_btn.png": "2b7a",
	"./fondo_newepisodios.jpg": "778f",
	"./fondo_newepisodios.svg": "1395",
	"./fondo_play_icons-orig.png": "c666",
	"./fondo_play_icons.png": "3ecd",
	"./fondo_series.jpg": "e5385",
	"./fondo_series.svg": "66e1",
	"./fondo_suelo_noche.png": "df89",
	"./fondoiglu.png": "b238",
	"./fondologin.jpg": "8b38",
	"./fondopancho.jpg": "588a",
	"./fondos_pinguiigluu.jpg": "0ed4",
	"./fondosection.jpg": "ab13",
	"./gamebackground.jpg": "942f",
	"./globe1.png": "97af",
	"./globe2.png": "28d1",
	"./globito.png": "aa81",
	"./glow.png": "acf9",
	"./gray_placeholder.png": "0b2c",
	"./ice-texture.png": "e66f",
	"./iconjuego.png": "67ab",
	"./iconos.png": "523a",
	"./iconver.png": "e302",
	"./iglu-globe-tail.png": "f058",
	"./iglu-globe.png": "1f42",
	"./iglu-on.png": "009a",
	"./iglu.jpg": "b4ec",
	"./iglu.png": "e993",
	"./iglu2.jpg": "4a43",
	"./igluglow - copia.jpg": "6ef5",
	"./igluglow.jpg": "4c3c",
	"./igluglow2 - copia.jpg": "4e35",
	"./igluglow2.jpg": "7678",
	"./iglushad.jpg": "b917",
	"./img_preferencias.jpg": "f8dd",
	"./index.html": "7769",
	"./ios.png": "c127",
	"./ios.png.webp": "dd6b",
	"./juegos.svg": "f49e",
	"./juegos.svg.webp": "758f",
	"./juegos_btn.png": "053f",
	"./juegos_btn.png.webp": "475d",
	"./juegosbg.jpg": "a206",
	"./jugando.png": "1e2c",
	"./jugando.png.webp": "1274",
	"./linea.png": "95f7",
	"./live-limit.png": "1fb2",
	"./liveplaceholder.jpg": "c0bd",
	"./loading.gif": "f8b2",
	"./locked.png": "2bd8",
	"./logo - copia.png": "d869",
	"./logo.png": "4ffd",
	"./logo.png.webp": "8765",
	"./logos.png": "7d90",
	"./logoviejo.png": "f895",
	"./logoviejo.png.webp": "6bb7",
	"./menubrush.png": "d874",
	"./menuic.png": "4815",
	"./mmicon.png": "f0d8",
	"./montana_noche.jpg": "9deb",
	"./multiplataforma-new.png": "ff51",
	"./multiplataforma-orig.png": "f763",
	"./multiplataforma.png": "c94f",
	"./mundo-mama-title.png": "8992",
	"./new/facebook.png": "77f2",
	"./new/facebook.png.webp": "e13f",
	"./new/instagram.png": "afa4",
	"./new/instagram.png.webp": "2688",
	"./new/pinguinitos-bg.jpg": "2673",
	"./new/pinguinitos-bg.jpg.webp": "d1e0",
	"./new/pinguinitos-bg.svg": "c950",
	"./new/platforms.png": "d60d",
	"./new/platforms.png.webp": "abed",
	"./new/x.png": "3b3b",
	"./new/x.png.webp": "fb51",
	"./new/youtube.png": "70fa",
	"./new/youtube.png.webp": "0301",
	"./nieve.png": "ce6b",
	"./no-player-banner.jpg": "dc00",
	"./nodisponible.png": "e115",
	"./noimg.jpg": "f328",
	"./noimg.png": "510b",
	"./panch_cuento_1.png": "2987",
	"./panch_cuento_2.png": "dc18",
	"./panch_cuento_3.png": "19a4",
	"./panch_cuento_4.png": "fcdb",
	"./panch_cuento_5.png": "f646",
	"./panch_cuento_6.png": "b94c",
	"./panch_cuento_6_nubes.png": "947f",
	"./panch_cuento_7.png": "15c7",
	"./panch_cuento_8.png": "3530",
	"./panch_cuento_8_barco.png": "04cb",
	"./panchito-hand.png": "3a32",
	"./panchito-nohand.png": "c762",
	"./panchito.png": "b9c1",
	"./panchito.png.webp": "ab21",
	"./panchito2.png": "2d72",
	"./pantalla.png": "4a7c",
	"./paypal.png": "7445",
	"./pensando.png": "ee88",
	"./pensando.png.webp": "dde3",
	"./pfondo.png": "5f63",
	"./pfondo2.png": "c240",
	"./pfondo3.png": "8a4d",
	"./phone_bg.jpg": "498d",
	"./pingbase.png": "1950",
	"./placeholder_16_9.png": "3de8",
	"./placeholder_1_1.png": "2955",
	"./play-icon.png": "6e2b",
	"./play-icon.png.webp": "e642",
	"./play-icon.svg.webp": "5cb7",
	"./player.png": "f2db",
	"./prox.png": "0c2e",
	"./rokustore.png": "44fc",
	"./rokustore.png.webp": "b8c8",
	"./rokustore2.png": "e757",
	"./rokustore3.png.webp": "ec74",
	"./seccion-title.png": "8893",
	"./senalando-izq.png": "7cd3",
	"./senalando-izq.png.webp": "5d58",
	"./senalando-izqca.png": "c234",
	"./senalando-izqca.png.webp": "ef43",
	"./senalando-izqcr.png": "6ff5",
	"./senalando-izqcr.png.webp": "62cd",
	"./senalando-izqdo.png": "eaa4",
	"./senalando-izqdo.png.webp": "e83d",
	"./senalando-izqgt.png": "62d5",
	"./senalando-izqgt.png.webp": "c554",
	"./senalando-izqhn.png": "94ae",
	"./senalando-izqhn.png.webp": "ae1d",
	"./senalando-izqmx.png": "03ac",
	"./senalando-izqmx.png.webp": "d409",
	"./senalando-izqni.png": "ccc1",
	"./senalando-izqni.png.webp": "f86e",
	"./senalando-izqpa.png": "b00c",
	"./senalando-izqpa.png.webp": "4fa8",
	"./senalando-izqpr.png": "aacf",
	"./senalando-izqpr.png.webp": "579c",
	"./senalando-izqsv.png": "bd70",
	"./senalando-izqsv.png.webp": "cfaf",
	"./senalando-izqus.png": "6a14",
	"./senalando-izqus.png.webp": "9201",
	"./senalando-izqve.png": "ca69",
	"./senalando-izqve.png.webp": "9b9b",
	"./senalando.png": "87cf",
	"./senalando2_btn.png": "ecb6",
	"./senalando_top.png": "03e8",
	"./senalandotxt.png": "72f5",
	"./series_btn.png": "6d4b",
	"./series_btn.png.webp": "9885",
	"./seriesbg.jpg": "c534",
	"./sesion_btn.png": "7964",
	"./shine.png": "b0ab",
	"./sol1.png": "be00",
	"./sol2.png": "8842",
	"./somoslogo.png": "ab3c",
	"./somosnext.png": "c02a",
	"./somosnext.png.webp": "123c",
	"./star.png": "ba5a",
	"./story/index.php": "3b56",
	"./tr.png": "063b",
	"./tvbox.png": "8e9e",
	"./tvbox2.png": "1d39",
	"./vercap.png": "dff2",
	"./vpromoicon.png": "6e35",
	"./vpromoicon.png.webp": "2313",
	"./wallpapers.svg": "b484",
	"./wallpapers.svg.webp": "e844"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";